import { defineWidgets } from '../utils/defineWidgets';

export const widgetsFootball = defineWidgets({
  "ld-football-leagues": () => import("./leagues/leagues.tsx"),
  "ld-football-competition-calendar-results": () => import("./competition-calendar-results/competitionCalendarResults.tsx"),
  "ld-football-team-calendar-results": () => import("./team-calendar-results/teamCalendarResults.tsx"),
  "ld-football-match-reports": () => import("./match-reports/matchReports.tsx"),
  "ld-football-match-reports-details": () => import("./match-reports-details/matchReportsDetails.tsx"),
});

export const widgetsLmp = defineWidgets({});

export const widgetsDataCards = defineWidgets({});

export const widgetsLiveScore = defineWidgets({});

export const widgetsMap = {
  ...widgetsFootball,
  ...widgetsLmp,
  ...widgetsDataCards,
  ...widgetsLiveScore,
};
